import { IHistoryItem } from './history-item.interface';

export type DirectionHistoryType = 'asc' | 'desc';

export enum EHistoryProvider {
  SMS = 'SMS',
  EMAIL = 'Email',
  WHATSAPP = 'WhatsApp',
  OUTLOOK = 'Outlook',
  FACEBOOK = 'Facebook',
  PHONE = 'Phone',
  LINE = 'Line',
  LIVE_CHAT = 'Copilot',
}

export interface IDateRange {
  fromDate: Date;
  toDate: Date;
}

export interface IHistoryOrderBy {
  field: keyof IHistoryItem;
  direction: DirectionHistoryType;
}

export interface IHistoryFilter {
  searchTerm: string;
  dateRange: IDateRange;
  orderBy: IHistoryOrderBy;
  exceptions: EHistoryProvider[];
}
